import React from 'react';
import styles from './Markdown.module.css';

type Props = {
  html: string;
};

export const HTMLToMarkdown = (props: Props) => {
  const { html } = props;

  return (
    <div
      className={styles.markdownBody}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};
